import { Controller } from "@hotwired/stimulus";
import { createRoot, type Root } from "react-dom/client";
import React from "react";

import GuestCheckout from "src/customer/guest_checkout";
import { newLookReviewOrderPath } from "src/routes";

export default class extends Controller {
  private root?: Root;
  static values = { firstName: String, lastName: String, email: String, phoneNumber: String };

  declare firstNameValue: string;
  declare lastNameValue: string;
  declare emailValue: string;
  declare phoneNumberValue: string;

  connect() {
    this.root = createRoot(this.element);

    this.root.render(this.guestControllerComponent())
  }

  disconnect() {
    if (this.root) {
      this.root.unmount();
      this.root = undefined;
    }
  }

  private guestControllerComponent() {
    return React.createElement(
      GuestCheckout, {
        afterGuestCheckoutCallback: () => { window.location.assign(newLookReviewOrderPath()) },
        initialDetails: {
          firstName: this.firstNameValue,
          lastName: this.lastNameValue,
          email: this.emailValue,
          phoneNumber: this.phoneNumberValue,
        },
      }
    );
  }
}
